<ng-container *transloco="let t; read: 'reports'">
<div class="rounded-lg fix-action-row modal-body max-w-[800px]">
  <div class="flex justify-between border-b">
    <h1 class="text-[25px] font-bold">{{data.measureCode}} {{data.measureName}}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>
  <div mat-dialog-content>
    <div class="col-span-2 mt-2 mb-6">
      <label class="font-normal mb-2">{{ t('activityAssignment.selectedChildren') }}</label>
      <ul>
        @for (child of data.studentNames; track child) {
          <li>{{child}}</li>
        }
      </ul>
    </div>

    <label class="font-normal my-2">{{ t('activityAssignment.selectActivities') }}</label>
    <div role="group" [attr.aria-label]="t('activityAssignment.activitiesAriaLabel')">
      @if (data.activities.length) {
        @for (activity of data.activities; track activity) {
          <input class="mt-2" type="checkbox" (change)="onActivitySelection(activity)">
            {{activity.activity}}
            <br>
        }
      }
      @else {
        <div>{{ t('activities.notAvailable') }}</div>
      }
    </div>
  </div>
  <div mat-dialog-actions class="flex justify-end">
    <drdp-btn color="cancel" mat-button mat-dialog-close>{{ 'common.cancel' | transloco }}</drdp-btn>
    <drdp-btn [disabled]="selectedActivityIds.length < 1" class="ml-3" mat-button (click)="onSave()">{{ 'common.save' | transloco }}</drdp-btn></div>
  </div>
</ng-container>
